import { type BaseModel } from 'src/models';
import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	textContainer: {
		'& p': {
			fontSize: 14,
			fontWeight: 500,
		},
		'& span': {
			fontSize: 14,
			fontWeight: 600,
			marginRight: 8,
		},
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
	},
}));

interface Props {
	model: BaseModel;
}

export function Trackers({ model }: Props) {
	const classes = useStyles();
	const { createdBy, createdById, updatedBy, updatedById } = model;

	return (
		<Grid container style={{ padding: '0px 16px' }}>
			{createdById && (
				<Grid className={classes.textContainer} item xs={12}>
					<span> Creado por: </span>

					<p>
						{' '}
						{createdBy?.firstname} {createdBy?.lastname}{' '}
					</p>
				</Grid>
			)}

			{updatedById && (
				<Grid className={classes.textContainer} item xs={12}>
					<span> Actualizado por: </span>

					<p>
						{' '}
						{updatedBy?.firstname} {updatedBy?.lastname}{' '}
					</p>
				</Grid>
			)}
		</Grid>
	);
}
